export default "__VITE_ASSET__DS0i4t8N__"